import { render, staticRenderFns } from "./RightModal.vue?vue&type=template&id=1dba20df&scoped=true&"
import script from "./RightModal.vue?vue&type=script&lang=js&"
export * from "./RightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dba20df",
  null
  
)

export default component.exports